import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { grey10, grey6 } from 'approot/shared/styles/colours.style';
import {
  FillInBlanksFieldCss,
  FillInBlanksFontSizeCss,
  FillInBlanksFontSizeProps,
  FillInBlanksLabelSupport,
  FillInBlanksPunctuationCss,
} from './fill-in-blanks-shared.style';

type FillInBlanksFieldProps = {
  $colours: ColourItem;
  $minWidth: number;
  $punctuation: string | null;
  $hasLabel: boolean;
  $hasTextOverflowed: boolean;
  $fontSize: string | null;
  $fontFamily: string | null;
};

export const FillInBlanksField = styled.div<FillInBlanksFieldProps>`
  display: inline-flex;

  ${({ $hasTextOverflowed, $minWidth = 100 }) =>
    $hasTextOverflowed
      ? `
      min-width: ${rem($minWidth)};
  `
      : `
    max-width: ${rem($minWidth)};
    width: 100%;
  `};

  ${FillInBlanksFontSizeCss}
  ${FillInBlanksFieldCss}
  ${FillInBlanksPunctuationCss}
`;

type FillInBlanksAnswerProps = {
  $colours: ColourItem;
  $label: string | null;
} & FillInBlanksFontSizeProps;
export const FillInBlanksFieldInner = styled.div<FillInBlanksAnswerProps>`
  position: relative;
  width: 100%;

  .tiptap {
    ${FillInBlanksFontSizeCss}
    outline: none;
    width: 100%;

    p {
      margin-bottom: 0;
    }
  }

  ${FillInBlanksLabelSupport}
`;

type FillInBlanksFieldTipTapProps = {
  $placeholder: string | null;
  $isScaffold: boolean;
};
export const FillInBlanksFieldTipTap = styled.div<FillInBlanksFieldTipTapProps>`
  padding: 0;
  position: relative;
  overflow: hidden;
  width: 100%;

  p {
    margin: 0;

    ${({ $placeholder, $isScaffold }) =>
      $placeholder &&
      `
      &:after {
        color: ${$isScaffold ? grey10 : grey6};
        content: '${$placeholder}';
        position: absolute;
        top: 0;
        pointer-events: none;
        white-space: nowrap;
      }
    `}
  }
`;

export const FillInBlanksFieldValue = styled.div<FillInBlanksFontSizeProps>`
  ${FillInBlanksFontSizeCss}
  outline: none;
  padding: 0;
  position: relative;
  width: 100%;

  p {
    margin-bottom: 0;
  }
`;
